interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({ title = 'Something went wrong', message, onRetry }: ErrorStateProps) {
  return (
    <div
      className="surface"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem',
        borderLeft: '4px solid rgba(220, 38, 38, 0.55)'
      }}
    >
      <div style={{ fontWeight: 600 }}>{title}</div>
      {message && <div className="text-muted">{message}</div>}
      {onRetry && (
        <div>
          <button
            type="button"
            onClick={onRetry}
            style={{
              background: 'var(--color-primary)',
              border: 'none',
              borderRadius: '10px',
              color: '#fff',
              padding: '0.45rem 1rem',
              cursor: 'pointer'
            }}
          >
            Try again
          </button>
        </div>
      )}
    </div>
  );
}

